import { render, staticRenderFns } from "./ModBus.vue?vue&type=template&id=3a0185d4&scoped=true&"
import script from "./ModBus.vue?vue&type=script&lang=js&"
export * from "./ModBus.vue?vue&type=script&lang=js&"
import style0 from "./ModBus.vue?vue&type=style&index=0&id=3a0185d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0185d4",
  null
  
)

export default component.exports